export const Experiment = {
  OttaCues: "20220720_OTTACUES",
  NewNotificationSettings: "20230621_NOTIFICATION_SETTINGS",
  CVUpload: "20230726_CV_UPLOAD",
  MinimisedJobCardV2: "20240328_MINIMISED_JOB_CARD_V2",
  SalaryNotProvided: "20240328_SALARY_NOT_PROVIDED",
  JobCardNavigation: "20240425_Search_App_Job_Card_Navigation",
} as const;
